import React, { useContext } from 'react'
import { 
  Container,
} from './style'
import CertificateOverview from './Overview'
import CertificateStructure from './Structure'
import CertificatesContext from '../../../../contexts/CertificatesContext'

const CertificateStructures: React.FC = () => {
  const { structureData } = useContext(CertificatesContext)

  return (
      <Container>
        <CertificateOverview/>
        {structureData.map((structure, index) => (
          <CertificateStructure key={structure.name} index={index}/>
        ))}
      </Container>
  )
}

export default CertificateStructures
